/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const greenApiWebhookTextMessageDataSchema = z.object({
	textMessage: z.string(),
});
